import { BLUE_BUTTON_ACCENT_COLOR, BLUE_BUTTON_ACCENT_COLOR_NUM, GREEN_BUTTON_ACCENT_COLOR, GREEN_BUTTON_ACCENT_COLOR_NUM, RED_BUTTON_ACCENT_COLOR, RED_BUTTON_ACCENT_COLOR_NUM } from './colors';
export const BUTTON_ACCENT_COLOR_NUMS = {
    red: RED_BUTTON_ACCENT_COLOR_NUM,
    blue: BLUE_BUTTON_ACCENT_COLOR_NUM,
    green: GREEN_BUTTON_ACCENT_COLOR_NUM
};
export const BUTTON_ACCENT_COLORS = {
    red: RED_BUTTON_ACCENT_COLOR,
    blue: BLUE_BUTTON_ACCENT_COLOR,
    green: GREEN_BUTTON_ACCENT_COLOR
};
